import Router from '../../router';
import {userService} from "../../services";

// initial state
const state = {
    loading: true,
    silentLoading: false,
    error: false,
    user: {
    },
    sessions: {
        count: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    allAboutMe({dispatch, commit}) {
        commit('setLoading', true);
        commit('setError', false);
        userService.allAboutMe().then(
            data => {
                commit('setAuthenticatedUserData', data.user);
                commit('setSessionsData', data.sessions);
            },
            error => {
                commit('setError', true);
            }
        ).then(function () {
            commit('setLoading', false);
        });
    },
    silentAllAboutMe({dispatch, commit}) {
        commit('setSilentLoading', true);
        commit('setError', false);
        userService.allAboutMe().then(
            data => {
                commit('setAuthenticatedUserData', data.user);
                commit('setSessionsData', data.sessions);
            },
            error => {
                commit('setError', true);
            }
        ).then(function () {
            commit('setSilentLoading', false);
        });
    }
};

// mutations
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setSilentLoading(state, loading) {
        state.silentLoading = loading;
    },
    setError(state, error) {
        state.error = error;
    },
    setAuthenticatedUserData(state, user) {
        if (!user){
            user = {}
        }
        state.user = user;
    },
    setSessionsData(state, sessions) {
        state.sessions = sessions;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}